import { useState } from 'react';
import { Icon, Ribbon, Text } from '@bitrise/bitkit';
import snarkdown from 'snarkdown';

import { getCookie, setCookie } from '@/utils/cookies';

export type AnnouncementBannerProps = {
  id: string;
  message: string | JSX.Element;
  link?: {
    title: string;
    url: string;
  };
};

const AnnouncementBanner = ({ id, message, link }: AnnouncementBannerProps): JSX.Element | null => {
  const isStringMessage = typeof message === 'string';
  const cookieId = `announcement-${id}`;
  const alreadySeen = getCookie(cookieId) !== null;
  const [showBanner, setShowBanner] = useState(!alreadySeen);

  if (!showBanner) {
    return null;
  }

  const onClose = () => {
    setShowBanner(false);
    setCookie(cookieId, 'seen');
  };

  return (
    <Ribbon
      colorScheme="blue"
      onClose={onClose}
      action={link ? { label: link.title, href: link.url } : undefined}
      display="flex"
      gap={8}
    >
      <Icon name="Info" />
      {isStringMessage ? <Text textAlign="left" dangerouslySetInnerHTML={{ __html: snarkdown(message) }} /> : message}
    </Ribbon>
  );
};

export default AnnouncementBanner;
